import {
  getOperation,
  fetchOperation,
  putOperation,
  fetchFinance,
} from "utils/api";

export const queryEmployeeDetail = async (employeeId) => {
  return await getOperation("/employee/detail", { employeeId: employeeId });
};

export const queryEmployeeConfig = async (params) => {
  return await getOperation("/employee/config", params);
};
// /employee/config?size=20&page=0&sort=createdDate%2Cdesc&employeeId=714
export const queryMerchantDetail = async (merchantId) => {
  return await getOperation("/merchant/detail", { merchantId: merchantId });
};

export const updateAllinPayKey = async (employeeId) => {
  return await fetchOperation("/key/renew", { employeeId: employeeId });
};

export const updateEmployeeConfig = async (params) => {
  return await fetchOperation("/employee/config/update", params);
};

export const updateEmployee = async (params) => {
  return await putOperation("/employee/detail", params);
};

export const updateEmployeeMidTid = async (params) => {
  return await fetchOperation("/employee/midtid/update", params);
};

export const createEmployee = async (params) => {
  return await fetchOperation("/employee/detail", params);
};

export const getMdr = async (merchantId) => {
  return await fetchFinance("/action", {
    action: "getMdr",
    merchantId: merchantId,
    method: "post",
  });
};

export const getPreference = async (params) => {
  return await getOperation("/merchant/preference", {
    ...params,
  });
};

// Reuse merchant list for employee related flows
export const queryAgentMerchant = async (params) => {
  return await getOperation("/merchant/list", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const queryMerchantOptions = async (params) => {
  return await getOperation("/merchant/options", {
    page: 0,
    size: 500,
    ...params,
  });
};
